export default __webpack_public_path__ + "static/media/29.9d73e662.jpg";